import type { HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/lib/utils';

const badgeVariants = cva(
	'inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-[0.04em] border',
	{
		variants: {
			variant: {
				default: 'bg-loomlite-purple/15 text-[#D9A9F5] border-loomlite-purple/35',
				outline: 'bg-transparent text-loomlite-muted border-loomlite-border',
				success: 'bg-loomlite-green/10 text-[#5CE7A8] border-loomlite-green/30',
				muted: 'bg-slate-400/10 text-loomlite-muted border-loomlite-border',
				gold: 'bg-loomlite-gold/10 text-loomlite-gold-soft border-loomlite-gold/35',
				danger: 'bg-red-500/10 text-red-300 border-red-500/30',
			},
		},
		defaultVariants: { variant: 'default' },
	},
);

export interface BadgeProps
	extends HTMLAttributes<HTMLDivElement>,
		VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
	return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}
